import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { useIncidentLogDataSubjectsField } from "./IncidentLogDataSubjectsField.hooks.ts";

export interface IncidentLogDataSubjectsFieldProps {
    dataSubjectIds: Array<string>;
    onChange: (dataSubjectIds: Array<string>) => void;
    isLoading: boolean;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogDataSubjectsField(props: IncidentLogDataSubjectsFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, dataSubjects } = useIncidentLogDataSubjectsField(props.isPreview);

    return (
        <DotLegalMultiSelect
            disabled={props.disabled}
            options={dataSubjects}
            isLoading={isLoading || props.isLoading}
            chosenOptions={props.dataSubjectIds}
            onChange={props.onChange}
            placeholder={translateString("categoryOfDataSubject")}
            label={translateString("categoryOfDataSubject")}
            noOptionsLabel={translateString("noOptions")}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogDataSubjectsField;
